webpackJsonp([1],Array(27).concat([
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidDate;
function formatDate(value, withTime) {
  var format = value.split('-');
  if (withTime === true) {
    var time = format[2].split(' ');
    return time[0] + '/' + format[1] + '/' + format[0] + ' ' + time[1];
  }
  return format[2] + '/' + format[1] + '/' + format[0];
}

function isValidDate(value, birthday) {
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
    return false;
  }

  var parts = value.split('/');

  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);

  if (year < 1000 || year > 3000 || month === 0 || month > 12) {
    return false;
  }

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
    monthLength[1] = 29;
  }

  if (day > 0 && day <= monthLength[month - 1]) {
    var date = new Date(month + '/' + day + '/' + year);
    var today = new Date();
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    if (birthday === true) {
      return +date <= +today;
    } else {
      return +date >= +today;
    }
  }
  return false;
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009a2d40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__(383);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009a2d40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(437);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  searching: '',
  user: null,
  token: null
};

var mutations = {
  setUser: function setUser(state, user) {
    state.user = user;
  },
  setToken: function setToken(state, token) {
    state.token = token;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({ state: state, mutations: mutations }));

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_Full__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_configs_Edit__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Dashboard__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_flights_List__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_flights_Store__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_guests_Edit__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_pages_Login__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_pages_Page404__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_pages_Page500__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_participants_Edit__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_participants_List__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_router__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(61);

















__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_12_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_0__containers_Full__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_2__views_Dashboard__["a" /* default */]
    }, {
      path: 'participantes/:updated?',
      name: 'Participantes',
      component: __WEBPACK_IMPORTED_MODULE_10__views_participants_List__["a" /* default */]
    }, {
      path: 'participante/:id/:guests?/:updatedGuest?',
      name: 'Participante',
      component: __WEBPACK_IMPORTED_MODULE_9__views_participants_Edit__["a" /* default */]
    }, {
      path: 'acompanhante/:id',
      name: 'Acompanhante',
      component: __WEBPACK_IMPORTED_MODULE_5__views_guests_Edit__["a" /* default */]
    }, {
      path: 'voos',
      name: 'Voos',
      component: __WEBPACK_IMPORTED_MODULE_3__views_flights_List__["a" /* default */]
    }, {
      path: 'voos/create',
      name: 'Manutenção de voo',
      component: __WEBPACK_IMPORTED_MODULE_4__views_flights_Store__["a" /* default */]
    }, {
      path: 'voos/create/:id',
      name: 'Editar voo',
      component: __WEBPACK_IMPORTED_MODULE_4__views_flights_Store__["a" /* default */]
    }, {
      path: 'configs/edit',
      name: 'Configurações',
      component: __WEBPACK_IMPORTED_MODULE_1__views_configs_Edit__["a" /* default */]
    }]
  }, {
    path: '*',
    redirect: '/default/404',
    name: 'Pages',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: __WEBPACK_IMPORTED_MODULE_7__views_pages_Page404__["a" /* default */]
    }, {
      path: '500',
      name: 'Page500',
      component: __WEBPACK_IMPORTED_MODULE_8__views_pages_Page500__["a" /* default */]
    }, {
      path: 'login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_6__views_pages_Login__["a" /* default */]
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.name !== 'Login' && (__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].state.token === null || __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].state.token === 'null')) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e153cc30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(410);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e153cc30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_json_excel__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(438);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('downloadExcel', __WEBPACK_IMPORTED_MODULE_3_vue_json_excel__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */];

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  }
});

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(197);
function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */,
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(198);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(205);
function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(206);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(223);
function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(224);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(246);
function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(247);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(252);
function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(253);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_29897b19_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__(279);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_29897b19_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_downloadjs__);





/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		'type': {
			type: String,
			default: "xls"
		},

		'data': {
			type: Array,
			required: true
		},

		'fields': {
			type: Object,
			required: true
		},

		'title': {
			type: String,
			default: null
		},

		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		idName: function idName() {
			var now = new Date().getTime();
			return 'export_' + now;
		}
	},
	methods: {
		generate: function generate() {
			if (!this.data.length) {
				return;
			}
			var json = this.getProcessedJson(this.data, this.fields);
			if (this.type == 'csv') {
				return this.export(this.jsonToCSV(json), this.name, "application/csv");
			}
			return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
		},

		export: function _export(data, filename, mime) {
			var blob = this.base64ToBlob(data, mime);
			__WEBPACK_IMPORTED_MODULE_1_downloadjs___default()(blob, filename, mime);
		},

		jsonToXLS: function jsonToXLS(data) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
			var xlsData = '<thead><tr>';

			if (this.title != null) {
				xlsData += '<tr><th colspan="' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[0]).length + '">' + this.title + '<th></tr>';
			}

			for (var key in data[0]) {
				xlsData += '<th>' + key + '</th>';
			}
			xlsData += '</tr></thead>';
			xlsData += '<tbody>';

			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var _key in item) {
					xlsData += '<td>' + item[_key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			return xlsTemp.replace('${table}', xlsData);
		},

		jsonToCSV: function jsonToCSV(data) {
			var csvData = '';

			if (this.title != null) {
				csvData += this.title + '\r\n';
			}

			for (var key in data[0]) {
				csvData += key + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';

			data.map(function (item) {
				for (var _key2 in item) {
					var escapedCSV = item[_key2] + '';
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			return csvData;
		},

		getProcessedJson: function getProcessedJson(data, header) {
			var keys = this.getKeys(data, header);
			var newData = [];
			var _self = this;
			data.map(function (item, index) {
				var newItem = {};
				for (var label in keys) {
					var property = keys[label];
					newItem[label] = _self.getNestedData(property, item);
				}
				newData.push(newItem);
			});

			return newData;
		},
		getKeys: function getKeys(data, header) {
			if (header) {
				return header;
			}

			var keys = {};
			for (var key in data[0]) {
				keys[key] = key;
			}
			return keys;
		},
		getNestedData: function getNestedData(key, item) {
			var valueFromNestedKey = null;
			var keyNestedSplit = key.split(".");
			valueFromNestedKey = item[keyNestedSplit[0]];
			for (var j = 1; j < keyNestedSplit.length; j++) {
				valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
			}
			return valueFromNestedKey == null ? '' : valueFromNestedKey;
		},
		base64ToBlob: function base64ToBlob(data, mime) {
			var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			var bstr = atob(base64);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		}
	} });

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052ef8a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(281)
  __webpack_require__(282)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052ef8a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d23f44be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d23f44be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(288);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  }, {
    name: 'Participantes',
    url: '/participantes',
    icon: 'fa fa-users'
  }, {
    name: 'Voos',
    url: '/voos',
    icon: 'fa fa-plane'
  }, {
    name: 'Configurações',
    url: '/configs/edit',
    icon: 'fa fa-cogs'
  }]
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2c0f710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(291);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2c0f710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside'
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1748bbe5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(294);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1748bbe5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{key:item.name,staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1febee05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(297);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1febee05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c81da794_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(300);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c81da794_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://www.origamieventos.com.br/","target":"_blank"}},[_vm._v("Origami Eventos")]),_vm._v(" © 2023.")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("\n    Criado por "),_c('a',{attrs:{"href":"https://www.extremedigital.com.br/eds/","target":"_blank"}},[_vm._v("EDS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e6be34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(306);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e6be34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__ = __webpack_require__(303);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  components: {
    HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa5b0b14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__(305);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa5b0b14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown',
  data: function data() {
    return { itemsCount: 42, loading: false };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      this.loading = true;
      this.$http.post('auth/logout').then(function (response) {
        _this.$store.commit('setUser', null);
        _this.$store.commit('setToken', null);
        window.localStorage.setItem('origami_admin_user', null);
        window.localStorage.setItem('origami_admin_token', null);
        _this.loading = false;
        _this.$router.push({ name: 'Login' });
      }).catch(function (response) {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-sign-out"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Sair")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('HeaderDropdown')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43714ab0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(345);
function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43714ab0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavItem__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavLink__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavTitle__ = __webpack_require__(342);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  data: function data() {
    return {
      loading: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      message: ''
    };
  },

  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_7__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_8__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_6__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    excel: function excel() {
      var _this = this;

      this.loading = true;
      this.$http.get('participants/excel').then(function (response) {
        _this.message = response.data.message;
        _this.showAlert();
        _this.loading = false;
      }).catch(function (response, err) {
        console.error(err);
        _this.loading = false;
      });
    },
    excelParticipantsGuests: function excelParticipantsGuests() {
      var _this2 = this;

      this.loading = true;
      this.$http.get('participants/excel-participants-guests').then(function (response) {
        _this2.message = response.data.message;
        _this2.showAlert();
        _this2.loading = false;
      }).catch(function (response, err) {
        _this2.loading = false;
      });
    },
    excelParticipants: function excelParticipants() {
      var _this3 = this;

      this.loading = true;
      this.$http.get('participants/excel-participants').then(function (response) {
        _this3.message = response.data.message;
        _this3.showAlert();
        _this3.loading = false;
      }).catch(function (response, err) {
        _this3.loading = false;
      });
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert: function showAlert() {
      this.dismissCountDown = this.dismissSecs;
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d4fc96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(312);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d4fc96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b81d956_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(315);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b81d956_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da48d316_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(318);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da48d316_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061be4a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061be4a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40823042_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(332);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40823042_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28fddf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(335);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28fddf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d816119_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(338);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d816119_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e023b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(341);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e023b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b32fdaa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(344);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b32fdaa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('b-alert',{staticClass:"float-position-alert",attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":"success"},on:{"dismissed":function($event){_vm.dismissCountDown = 0},"dismiss-count-down":_vm.countDownChanged}},[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('b-progress',{attrs:{"variant":"success","max":_vm.dismissSecs,"value":_vm.dismissCountDown,"height":"4px"}})],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]}),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":_vm.excel}},[_vm._m(0,false,false)])],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Planilha ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f74a954_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(348);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f74a954_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394e87a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(374);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394e87a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methods_helpers__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "edit-configs",
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default.a
  },
  components: {},
  data: function data() {
    return {
      userFile: null,
      rankingFile: null,
      loading: false,
      id: undefined,
      final_register: undefined,
      start_flight: undefined,
      final_flight: undefined,
      travel: undefined,
      start_champion: undefined,
      final_champion: undefined,
      start_super: undefined,
      final_super: undefined,
      start_gold: undefined,
      final_gold: undefined,
      start_silver: undefined,
      final_silver: undefined,
      start_bronze: undefined,
      final_bronze: undefined,
      final_event: undefined,
      start_event: undefined,
      users: [],
      fields: [{ key: "user", label: "Participante", formatter: "fullName" }, "status"],
      charge: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.userId = this.$router.history.current.params.id;
    this.$http.get("configs").then(function (response) {
      _this.loading = false;
      var configs = response.data.configs;

      _this.id = configs.id;
      _this.final_register = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_register, true);
      _this.start_flight = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.start_flight, true);
      _this.final_flight = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_flight, true);
      _this.travel = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.travel, true);
      _this.start_champion = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.start_champion, true);
      _this.final_champion = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_champion, true);
      _this.start_super = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.start_super, true);
      _this.final_super = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_super, true);
      _this.start_gold = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.start_gold, true);
      _this.final_gold = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_gold, true);
      _this.start_silver = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.start_silver, true);
      _this.final_silver = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_silver, true);
      _this.start_bronze = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.start_bronze, true);
      _this.final_bronze = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_bronze, true);
      _this.start_event = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.start_event, true);
      _this.final_event = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](configs.final_event, true);
      _this.loading = false;
    }).catch(function (error) {
      console.error(error);
      _this.loading = false;
    });
  },

  methods: {
    back: function back() {
      this.$router.push({
        name: "Dashboard"
      });
    },
    create: function create(isInvalid) {
      var _this2 = this;

      if (isInvalid === false) {
        this.loading = true;
        this.$http.put("configs", {
          id: this.id,
          final_register: this.final_register,
          start_flight: this.start_flight,
          final_flight: this.final_flight,
          travel: this.travel,
          start_champion: this.start_champion,
          final_champion: this.final_champion,
          start_super: this.start_super,
          final_super: this.final_super,
          start_gold: this.start_gold,
          final_gold: this.final_gold,
          start_silver: this.start_silver,
          final_silver: this.final_silver,
          start_bronze: this.start_bronze,
          final_bronze: this.final_bronze,
          start_event: this.start_event,
          final_event: this.final_event
        }).then(function () {
          _this2.loading = false;
          _this2.$router.push({
            name: "Dashboard"
          });
        }).catch(function (error) {
          console.error(error);
          _this2.loading = false;
        });
      }
    },
    upload: function upload() {
      var _this3 = this;

      this.loading = true;
      var formData = new FormData();
      formData.append("excel", this.userFile);
      this.users = [];
      this.$http.post("users/excel", formData).then(function (resp) {
        _this3.loading = false;
        _this3.users = resp.data.users;
        _this3.charge = true;
        _this3.userFile = null;
      }).catch(function (error) {
        console.error(error);
        _this3.loading = false;
        _this3.userFile = null;
      });
    },
    uploadRanking: function uploadRanking() {
      var _this4 = this;

      this.loading = true;
      var formData = new FormData();
      formData.append("excel", this.rankingFile);
      this.$http.post("users/rank", formData).then(function (resp) {
        _this4.loading = false;
        _this4.charge = true;
        _this4.rankingFile = null;
      }).catch(function (error) {
        console.error(error);
        _this4.loading = false;
        _this4.rankingFile = null;
      });
    },
    fullName: function fullName(value) {
      return value.code + " - " + value.name + "    |    " + value.e_mail;
    }
  },
  validations: function validations() {
    return {
      final_register: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      start_flight: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      final_flight: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      travel: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      start_champion: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      final_champion: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      start_super: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      final_super: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      start_gold: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      final_gold: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      start_silver: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      final_silver: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      start_bronze: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      final_bronze: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      start_event: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      final_event: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] }
    };
  }
});

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Info!","ok-variant":"primary","ok-only":""},on:{"ok":function($event){_vm.charge = false}},model:{value:(_vm.charge),callback:function ($$v) {_vm.charge=$$v},expression:"charge"}},[_vm._v("\n    Carregamento efetuado com sucesso.\n  ")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Datas de cadastro/escolha de voo")]),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data de início do evento"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],attrs:{"type":"text"},model:{value:(_vm.start_event),callback:function ($$v) {_vm.start_event=$$v},expression:"start_event"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data do fim do evento"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],attrs:{"type":"text"},model:{value:(_vm.final_event),callback:function ($$v) {_vm.final_event=$$v},expression:"final_event"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data final do pré cadastro"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.final_register.$invalid },attrs:{"type":"text"},model:{value:(_vm.final_register),callback:function ($$v) {_vm.final_register=$$v},expression:"final_register"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data do primeiro voo"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.start_flight.$invalid },attrs:{"type":"text"},model:{value:(_vm.start_flight),callback:function ($$v) {_vm.start_flight=$$v},expression:"start_flight"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data do último voo"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.final_flight.$invalid },attrs:{"type":"text"},model:{value:(_vm.final_flight),callback:function ($$v) {_vm.final_flight=$$v},expression:"final_flight"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data para cálculo da idade"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.travel.$invalid },attrs:{"type":"text"},model:{value:(_vm.travel),callback:function ($$v) {_vm.travel=$$v},expression:"travel"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Champion Início"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.start_champion.$invalid },attrs:{"type":"text"},model:{value:(_vm.start_champion),callback:function ($$v) {_vm.start_champion=$$v},expression:"start_champion"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Champion final"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.final_champion.$invalid },attrs:{"type":"text"},model:{value:(_vm.final_champion),callback:function ($$v) {_vm.final_champion=$$v},expression:"final_champion"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Super Início"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.start_super.$invalid },attrs:{"type":"text"},model:{value:(_vm.start_super),callback:function ($$v) {_vm.start_super=$$v},expression:"start_super"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Super final"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.final_super.$invalid },attrs:{"type":"text"},model:{value:(_vm.final_super),callback:function ($$v) {_vm.final_super=$$v},expression:"final_super"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Gold Início"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.start_gold.$invalid },attrs:{"type":"text"},model:{value:(_vm.start_gold),callback:function ($$v) {_vm.start_gold=$$v},expression:"start_gold"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Gold final"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.final_gold.$invalid },attrs:{"type":"text"},model:{value:(_vm.final_gold),callback:function ($$v) {_vm.final_gold=$$v},expression:"final_gold"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Silver Início"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.start_silver.$invalid },attrs:{"type":"text"},model:{value:(_vm.start_silver),callback:function ($$v) {_vm.start_silver=$$v},expression:"start_silver"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Silver final"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.final_silver.$invalid },attrs:{"type":"text"},model:{value:(_vm.final_silver),callback:function ($$v) {_vm.final_silver=$$v},expression:"final_silver"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Bronze Início"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.start_bronze.$invalid },attrs:{"type":"text"},model:{value:(_vm.start_bronze),callback:function ($$v) {_vm.start_bronze=$$v},expression:"start_bronze"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Bronze final"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999 99:99:99'),expression:"'99/99/9999 99:99:99'"}],class:{ 'is-invalid': _vm.$v.final_bronze.$invalid },attrs:{"type":"text"},model:{value:(_vm.final_bronze),callback:function ($$v) {_vm.final_bronze=$$v},expression:"final_bronze"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"12 text-right"}},[_c('b-button',{attrs:{"variant":"default"},on:{"click":_vm.back}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v("  Voltar\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.create(_vm.$v.$invalid)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("  Salvar\n            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Carga de participantes")]),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-file',{attrs:{"browse-text":"'Selecionar'","state":Boolean(_vm.userFile),"placeholder":"Selecione o arquivo ou arraste ele aqui...","drop-placeholder":"'Arraste seu arquivo aqui...'","accept":".xls"},model:{value:(_vm.userFile),callback:function ($$v) {_vm.userFile=$$v},expression:"userFile"}})],1)],1),_vm._v(" "),(Boolean(_vm.userFile))?_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"12 text-right"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.upload()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("  Upload\n            ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.users.length > 0)?_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.users,"fields":_vm.fields}},[[_c('b',{staticClass:"text-info"},[_vm._v(_vm._s(_vm.data))])]],2)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Atualização de premiação")]),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-file',{attrs:{"browse-text":"'Selecionar'","state":Boolean(_vm.rankingFile),"placeholder":"Selecione o arquivo ou arraste ele aqui...","drop-placeholder":"'Arraste seu arquivo aqui...'","accept":".xls"},model:{value:(_vm.rankingFile),callback:function ($$v) {_vm.rankingFile=$$v},expression:"rankingFile"}})],1)],1),_vm._v(" "),(Boolean(_vm.rankingFile))?_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"12 text-right"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.uploadRanking()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("  Upload\n            ")])],1)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081595a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081595a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      data: {
        totalUsers: 0,
        guests: 0,
        pendingFlight: 0,
        pendingUsers: 0,
        completedFlight: 0,
        completedUsers: 0,
        completedGuests: 0,
        extraGuests: 0,
        countFlights: {
          flights: []
        }
      },
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.$http.get('dashboard').then(function (response) {
      _this.data = response.data;
      _this.loading = false;
    }).catch(function () {
      _this.loading = false;
    });
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.data.totalUsers)+"\n            "),_c('span',{staticClass:"pull-right",staticStyle:{"font-size":"19px"}},[_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Participantes cadastrados no sistema")])]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"10px"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.data.pendingUsers)+"\n            "),_c('span',{staticClass:"pull-right",staticStyle:{"font-size":"19px"}},[_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Participantes não cadastrados no sistema")])]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"10px"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.data.guests)+"\n            "),_c('span',{staticClass:"pull-right",staticStyle:{"font-size":"19px"}},[_c('i',{staticClass:"fa fa-users"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Acompanhantes cadastrados no sistema")])]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"10px"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.data.completedFlight)+"\n            "),_c('span',{staticClass:"pull-right",staticStyle:{"font-size":"19px"}},[_c('i',{staticClass:"fa fa-plane"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Participantes com seleção de voo concluída.")])]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"10px"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.data.completedGuests)+"\n            "),_c('span',{staticClass:"pull-right",staticStyle:{"font-size":"19px"}},[_c('i',{staticClass:"fa fa-plane"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Acompanhantes com voo selecionado.")])]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"10px"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.data.extraGuests)+"\n            "),_c('span',{staticClass:"pull-right",staticStyle:{"font-size":"19px"}},[_c('i',{staticClass:"fa fa-plane"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("Acompanhantes extras.")])]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"10px"}})],1)],1),_vm._v(" "),_vm._l((_vm.data.countFlights.flights),function(flight){return (flight.company)?_c('b-col',{key:flight.id,attrs:{"sm":"6","lg":"3"}},[_c('b-card',{class:{'bg-light': flight.available > 10, 'bg-secondary': flight.available <= 10},attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h6',{staticClass:"mb-0"},[_vm._v(" Grupo "+_vm._s(flight.group_number)+"\n            "),_vm._v(" "),_c('span',{staticClass:"pull-right",staticStyle:{"font-size":"19px"}},[_c('i',{staticClass:"fa fa-plane"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h6',[_vm._v("\n            Vagas disponíveis: "+_vm._s(flight.available)+" "),_c('br'),_vm._v("\n            Total de vagas: "+_vm._s(flight.available_places)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper px-3",staticStyle:{"height":"19px"}})],1)],1):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502ce454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502ce454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Table_vue__ = __webpack_require__(28);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "tables",
  components: { cTable: __WEBPACK_IMPORTED_MODULE_0__components_Table_vue__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      pending: false,
      showDismissibleAlert: false,
      hasErrors: false,
      item: {},
      items: [],
      fields: [{ key: "group_number", label: "Nº do Grupo", sortable: true }, { key: "city", label: "Cidade", sortable: true }, { key: "company", label: "Companhia Aérea", sortable: true }, { key: "available", label: "Disponíveis", sortable: true }, { key: "available_places", label: "Total", sortable: true }, { key: "actions", label: "Ações", sortable: true }],
      participants: [],
      participantFields: [{ key: "badge_name", label: "Nome de reconhecimento", sortable: true }, { key: "cpf", label: "CPF", sortable: true }, { key: "rg", label: "RG", sortable: true }, { key: "validadeRg", label: "Validade do RG", sortable: true }, { key: "email", label: "Email", sortable: true }, { key: "actions", label: "Ações", sortable: false }],
      deleteFlightId: null
    };
  },
  mounted: function mounted() {
    this.getFlights();
  },

  methods: {
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert: function showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getFlights: function getFlights() {
      var _this = this;

      this.loading = true;
      this.$http.get("flights").then(function (response) {
        _this.items = response.data.flights;
        _this.items.forEach(function (item) {
          item.departure_date = item.departure_flight + " - " + item.departure_date.substr(0, 19);
          item.return_date = item.return_flight + " - " + item.return_date.substr(0, 19);
          item.actions = { show: true, id: item.id, route: "Voo" };
        });
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.loading = true;
      var id = this.item[0].id;
      var data = { id: id, available_places: this.item.available_places };
      this.$http.put("flights/" + id, data).then(function (response) {
        _this2.loading = false;
        _this2.getFlights();
        _this2.showAlert();
        _this2.$root.$emit("bv::hide::modal", "modallg" + id);
      }).catch(function () {
        _this2.$root.$emit("bv::hide::modal", "modallg" + id);
        _this2.hasErrors = true;
        _this2.loading = false;
      });
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showModal: function showModal(modal) {
      var _this3 = this;

      this.$root.$emit("bv::show::modal", "modallg" + modal);
      this.item = this.items.filter(function (item) {
        return item.id === modal;
      });
      this.participants = this.item[0].participants.map(function (item) {
        item.actions = { show: true, id: item.user.id, route: "Participante" };
        return item;
      });
      this.item[0].guests.map(function (item) {
        item.actions = { show: true, id: item.participant.user_id, route: "Participante" };
        console.log(item);
        item.badge_name = item.name + ' | Acompanhante de: ' + item.participant.badge_name;
        _this3.participants.push(item);
        return item;
      });
    },
    editFlight: function editFlight(id) {
      this.$router.push({
        name: "Editar voo",
        params: { id: id }
      });
    },
    deleteFlight: function deleteFlight() {
      var _this4 = this;

      this.$http.delete("flights/" + this.deleteFlightId).then(function (response) {
        _this4.loading = false;
        _this4.getFlights();
      }).catch(function () {
        _this4.hasErrors = true;
        _this4.loading = false;
      });
    },
    storeFlight: function storeFlight() {
      this.$router.push({ name: "Manutenção de voo" });
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__methods_helpers__ = __webpack_require__(27);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    modalTitle: '',
    items: '',
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    excelFields: Object,
    excelData: Array,
    excelName: String
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      pending: false,
      json_fields: {},
      json_data: [],
      json_meta: [[{
        key: 'charset',
        value: 'utf-8'
      }]],
      deleteUserId: null,
      errorMessage: null,
      hasErrors: false,
      emailSended: false,
      emailSendedMessage: '',
      loading: false
    };
  },
  methods: {
    showModal: function showModal(modal) {
      this.$root.$emit('bv::show::modal', 'modallg' + modal);
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getBadge: function getBadge(status) {
      return status === 'Concluído' ? 'success' : status === 'Inativo' ? 'secondary' : status === 'Pendente' ? 'warning' : status === 'Banido' ? 'danger' : 'primary';
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    edit: function edit(action) {
      if (action !== undefined && action.id !== undefined) {
        if (action.edit !== undefined && action.edit === 'order') {
          this.$parent.$parent.editOrder = true;
          this.$parent.$parent.currentOrder = action.id;
        } else {
          this.$router.push({ name: action.route, params: { id: action.id } });
        }
      }
    },
    formatDate: function formatDate(date) {
      if (date !== undefined && date !== null) {
        return __WEBPACK_IMPORTED_MODULE_0__methods_helpers__["a" /* formatDate */](date);
      }
      return '';
    },
    deletePartifipant: function deletePartifipant() {
      var _this = this;

      this.loading = true;
      this.$http.delete('participants/' + this.deleteUserId).then(function (response) {
        _this.loading = false;
        if (response.data.code === 200) {
          _this.$router.go();
        } else {
          _this.hasErrors = true;
          _this.errorMessage = response.data.msg;
        }
      }).catch(function (error) {
        console.error(error);
        _this.errorMessage = response.data.msg;
        _this.hasErrors = true;
        _this.loading = false;
      });
    },
    notify: function notify() {
      var _this2 = this;

      this.loading = true;
      var id = this.items.map(function (elm) {
        return elm.id;
      });
      this.$http.post('users/notify', { id: id }).then(function () {
        _this2.loading = false;
        _this2.emailSended = true;
        _this2.emailSendedMessage = 'Emails enviados com sucesso!';
      }).catch(function (error) {
        console.error(error);
        _this2.loading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      _this3.json_fields = _this3.excelFields;
      _this3.json_data = _this3.excelData;
    }, 500);
  },

  watch: {
    pending: function pending(value) {
      this.$parent.getUsers(value);
    },
    excelData: function excelData(value) {
      this.json_data = this.$parent.items;
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":_vm.caption}},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Info!","ok-variant":"primary","ok-only":""},on:{"ok":function($event){_vm.emailSended = false}},model:{value:(_vm.emailSended),callback:function ($$v) {_vm.emailSended=$$v},expression:"emailSended"}},[_vm._v("\n    "+_vm._s(_vm.emailSendedMessage)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('b-button',{staticClass:"pull-right btn-sm",attrs:{"variant":"default"},on:{"click":function($event){_vm.notify()}}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v("  Enviar emails de registros\n    ")]),_vm._v(" "),_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-input-group',{staticStyle:{"margin-left":"-9%"}},[_c('b-form-input',{attrs:{"placeholder":"Buscar..."},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Erro!","ok-variant":"danger","ok-only":""},on:{"ok":function($event){_vm.hasErrors = false}},model:{value:(_vm.hasErrors),callback:function ($$v) {_vm.hasErrors=$$v},expression:"hasErrors"}},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-confirmation","title":"Exclusão de participante"},on:{"ok":function($event){_vm.deletePartifipant()}}},[_c('p',{staticClass:"my-4"},[_vm._v("Tem certeza que deseja excluir este participante?")])]),_vm._v(" "),_c('b-table',{staticClass:"table-responsive-sm",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"items":_vm.items,"fields":_vm.fields,"filter":_vm.filter,"current-page":_vm.currentPage,"per-page":_vm.perPage},on:{"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"status",fn:function(data){return [_c('b-badge',{attrs:{"variant":_vm.getBadge(data.item.status)}},[_vm._v(_vm._s(data.item.status))])]}},{key:"selected",fn:function(data){return [_c('b-badge',{attrs:{"variant":(data.item.selected === 'Qualificado' || data.item.selected === 'Extra') ? 'success' : 'danger'}},[_vm._v("\n        "+_vm._s(data.item.selected)+"\n      ")])]}},{key:"formattedPassport",fn:function(data){return [_c('b-badge',{attrs:{"variant":data.item.formattedPassport === 'Sim' ? 'success' : 'danger'}},[_vm._v("\n        "+_vm._s(data.item.formattedPassport)+"\n      ")])]}},{key:"actions",fn:function(data){return data.item.actions?[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-confirmation",modifiers:{"modal-confirmation":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"size":"sm","variant":"primary","title":"Excluir"},on:{"click":function($event){_vm.deleteUserId = data.item.id}}},[_c('i',{staticClass:"fa fa-trash"})]),_vm._v(" "),(data.item.actions.modal)?_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.showModal(data.item.id)}}},[_c('i',{staticClass:"fa fa-folder-open"})]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.edit(data.item.actions)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('b-modal',{attrs:{"id":'modallg' + data.item.id,"size":"lg","ok-only":"","title":data.item.actions.modalTitle}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"text-center",attrs:{"header":"Pessoal","header-tag":"header"}},[_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(data.item.name))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Nascimento:")]),_vm._v(" "+_vm._s(_vm.formatDate(data.item.dateOfBirth))+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Idade:")]),_vm._v(" "+_vm._s(data.item.age))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Parentesco:")]),_vm._v(" "+_vm._s(data.item.type))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("CPF")]),_vm._v(": "+_vm._s(data.item.cpf))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("RG")]),_vm._v(": "+_vm._s(data.item.rg))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Validade do RG")]),_vm._v(": "+_vm._s(data.item.validadeRg))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Celular:")]),_vm._v(" "+_vm._s(data.item.cellPhone))])]),_vm._v(" "),_c('b-card',{staticClass:"text-center",attrs:{"header":"Geral","header-tag":"header"}},[_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Qtd de PTC's anteriores:")]),_vm._v(" "+_vm._s(data.item.ptcCount))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Restrição alimentar:")]),_vm._v(" "+_vm._s(data.item.food))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Necessidades especiais:")]),_vm._v(" "+_vm._s(data.item.specialNeeds))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('strong',[_vm._v("Observação:")]),_vm._v(" "+_vm._s(data.item.observation))])])],1)],1)])])]:undefined}}])}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.items),"per-page":_vm.perPage,"prev-text":"Anterior","next-text":"Próximo","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":"success"},on:{"dismissed":function($event){_vm.dismissCountDown = 0},"dismiss-count-down":_vm.countDownChanged}},[_c('p',[_vm._v("Voo atualizado com sucesso!")]),_vm._v(" "),_c('b-progress',{attrs:{"variant":"success","max":_vm.dismissSecs,"value":_vm.dismissCountDown,"height":"4px"}})],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Erro!","ok-variant":"danger","ok-only":""},on:{"ok":function($event){_vm.hasErrors = false}},model:{value:(_vm.hasErrors),callback:function ($$v) {_vm.hasErrors=$$v},expression:"hasErrors"}},[_vm._v("\n    Não foi possível atualizar o voo.\n  ")]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-confirmation","title":"Exclusão de voo"},on:{"ok":function($event){_vm.deleteFlight()}}},[_c('p',{staticClass:"my-4"},[_vm._v("Tem certeza que deseja excluir este voo?")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{attrs:{"header":"<i class='fa fa-plane'></i> Lista de Voos"}},[_c('div',{staticClass:"row d-flex justify-content-between"},[_c('b-button',{staticClass:"ml-3",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.storeFlight()}}},[_vm._v("\n            Cadastrar Voo"),_c('i',{staticClass:"fa fa-plane pl-2"})]),_vm._v(" "),_c('b-form-group',{staticClass:"mb-0",attrs:{"horizontal":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Buscar..."},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-search"})])],1)],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b-table',{staticClass:"table-responsive-sm",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"items":_vm.items,"fields":_vm.fields,"filter":_vm.filter,"current-page":_vm.currentPage,"per-page":_vm.perPage},on:{"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"actions",fn:function(data){return [_c('b-row',{staticClass:"form-group"},[(data.item.available_places === data.item.available)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-confirmation",modifiers:{"modal-confirmation":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"size":"sm","variant":"primary","title":"Excluir"},on:{"click":function($event){_vm.deleteFlightId = data.item.id}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e(),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"size":"sm","variant":"primary","title":"Editar"},on:{"click":function($event){_vm.editFlight(data.item.id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"size":"sm","variant":"primary","title":"Visualizar participantes"},on:{"click":function($event){_vm.showModal(data.item.id)}}},[_c('i',{staticClass:"fa fa-folder-open"})])],1)]}}])}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.items),"per-page":_vm.perPage,"prev-text":"Anterior","next-text":"Próximo","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1),_vm._v(" "),_vm._l((_vm.items),function(flight){return _c('b-modal',{key:flight.id,attrs:{"id":'modallg' + flight.id,"size":"lg","ok-only":"","title":'Vagas disponíveis: ' +
      flight.available +
      ' - Total de vagas: ' +
      flight.available_places}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-form',{attrs:{"inline":""}},[_c('label',{staticClass:"sr-only"},[_vm._v("Quantidade de vagas")]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"left":""}},[_c('b-input',{attrs:{"placeholder":"Quantidade de vagas"},model:{value:(_vm.item.available_places),callback:function ($$v) {_vm.$set(_vm.item, "available_places", $$v)},expression:"item.available_places"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.update}},[_vm._v("Salvar")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('c-table',{attrs:{"striped":"","items":_vm.participants,"fields":_vm.participantFields,"caption":"<i class='fa fa-users'></i> Lista de Participantes que selecionaram este voo"}})],1)],1)],1)])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Store_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192457d7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Store_vue__ = __webpack_require__(404);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Store_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192457d7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Store_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_awesome_mask__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "store-flight",
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_2_awesome_mask___default.a
  },
  components: {},
  data: function data() {
    return {
      loading: false,
      id: undefined,
      company: undefined,
      group_number: undefined,
      available_places: undefined,
      locator: undefined,
      attachment_binary: undefined,
      city: undefined,
      flightId: undefined
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.flightId = this.$router.history.current.params.id;
    if (this.flightId) {
      this.loading = true;
      this.$http.get("flights/edit/" + this.flightId, {}).then(function (response) {
        var flight = response.data.flight;

        _this.id = flight.id, _this.company = flight.company, _this.available_places = flight.available_places, _this.group_number = flight.group_number, _this.attachment_binary = flight.attachment_binary, _this.city = flight.city, _this.locator = flight.locator;

        _this.loading = false;
      }).catch(function (error) {
        console.error(error);
        _this.hasErrors = true;
        _this.loading = false;
      });
    }
  },

  methods: {
    back: function back() {
      this.$router.push({
        name: "Voos"
      });
    },

    filesChange: function filesChange(fileList) {
      this.newUpload = this.attachment_binary = fileList[0];
    },
    create: function create(isInvalid) {
      var _this2 = this;

      if (isInvalid === false) {
        this.loading = true;

        var formData = new FormData();
        var flight = {
          company: this.company,
          group_number: this.group_number,
          available_places: this.available_places,

          attachment_binary: this.attachment_binary,
          city: this.city
        };
        if (this.id !== undefined) {
          flight.id = this.id;
        }
        this.buildFormData(formData, flight);
        this.$http.post("flights", formData).then(function () {
          _this2.loading = false;
          _this2.$router.push({
            name: "Voos"
          });
        }).catch(function (error) {
          console.error(error);
          _this2.hasErrors = true;
          _this2.loading = false;
        });
      }
    },

    buildFormData: function buildFormData(formData, data, parentKey) {
      var _this3 = this;

      if (data && (typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === "object" && !(data instanceof Date) && !(data instanceof File)) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this3.buildFormData(formData, data[key], parentKey ? parentKey + "[" + key + "]" : key);
        });
      } else {
        var value = data == null ? "" : data;
        formData.append(parentKey, value);
      }
    }
  },
  validations: function validations() {
    return {
      group_number: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(10) },
      company: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(255) },
      available_places: {},
      locator: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },

      departure_flight_number_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_flight_number_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_date_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_date_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_incoming_city_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_incoming_city_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_incoming_time_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_incoming_time_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_coming_city_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_coming_city_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_coming_time_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      departure_coming_time_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_flight_number_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_flight_number_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_date_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_date_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_incoming_city_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_incoming_city_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_incoming_time_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_incoming_time_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_coming_city_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_coming_city_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_coming_time_1: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
      return_coming_time_2: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) }
    };
  }
});

/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Cadastrar Voo")]),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Número do Grupo"}},[_c('b-input-group',[_c('b-form-input',{class:{ 'is-invalid': _vm.$v.group_number.$invalid },attrs:{"type":"number"},model:{value:(_vm.group_number),callback:function ($$v) {_vm.group_number=$$v},expression:"group_number"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Companhia Aérea"}},[_c('b-input-group',[_c('b-form-input',{class:{ 'is-invalid': _vm.$v.company.$invalid },attrs:{"type":"text"},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Lugares disponíveis"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.available_places),callback:function ($$v) {_vm.available_places=$$v},expression:"available_places"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Cidade"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('label',[_vm._v("Imagem dos voos")]),_vm._v(" "),_c('input',{ref:"fileupload",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.files)}}})]),_vm._v(" "),(typeof this.attachment_binary === 'string')?_c('b-col',{staticClass:"mt-2",attrs:{"md":"12"}},[_c('img',{attrs:{"src":'data:image/jpeg;base64,' + this.attachment_binary,"width":"100%"}})]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"12 text-right"}},[_c('b-button',{attrs:{"variant":"default"},on:{"click":_vm.back}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v("  Voltar\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.create(_vm.$v.$invalid)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("  Salvar\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea3777a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(411);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea3777a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_orders_List_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__methods_helpers__ = __webpack_require__(27);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forms',
  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default.a
  },
  components: {
    'order-list': __WEBPACK_IMPORTED_MODULE_3__views_orders_List_vue__["a" /* default */]
  },
  data: function data() {
    return {
      cities: [],
      foods: [],
      pwdList: [],
      kinship: [],
      showDismissibleAlert: false,
      loading: false,
      hasErrors: false,
      notFound: false,
      editOrder: false,
      currentOrder: false,
      showGuests: false,
      guest: {
        id: false,
        name: '',
        cpf: '',
        rg: '',
        validade_rg: '',
        kinship: '',
        registration: '',
        cell_phone: '',
        date_of_birth: '',
        gender: '',

        has_passport: false,
        confirmInfo: false,
        completed: false,
        food_id: '',
        other_food: '',
        ptc_count: '',
        participant_id: false,
        attachment_name: '',
        passport_first_name: '',
        passport_last_name: '',
        passport_number: '',
        nacionality: '',
        passport_validity: '',
        start_city: '',
        return_city: '',
        support_point: '',
        city_support_point: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.$http.get('sync').then(function (response) {
      var data = response.data;
      _this.foods = data.foods.map(function (food) {
        return { value: food.id, text: food.name };
      });
      _this.pwdList = data.pwd.map(function (pwd) {
        return { value: pwd.id, text: pwd.name };
      });
      _this.kinship = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.kinship).map(function (objectKey, idx) {
        return { value: objectKey, text: data.kinship[objectKey] };
      });
    });
    var userId = this.$router.history.current.params.id;
    this.$http.get('guests/' + userId).then(function (response) {
      _this.guest = response.data.guest;
      _this.guest.date_of_birth = __WEBPACK_IMPORTED_MODULE_4__methods_helpers__["a" /* formatDate */](_this.guest.date_of_birth);
      if (_this.guest.passport_validity !== null) {
        _this.guest.passport_validity = __WEBPACK_IMPORTED_MODULE_4__methods_helpers__["a" /* formatDate */](_this.guest.passport_validity);
      }

      _this.loading = false;
      setTimeout(function () {
        _this.$v.guest.$reset();
      }, 1000);
    }).catch(function (error) {
      log.error(error);
      _this.notFound = true;
      _this.loading = false;
    });
  },

  methods: {
    back: function back() {
      if (this.guest.participant_id !== false) {
        this.$router.push({
          name: 'Participante',
          params: { id: this.guest.participant.user_id, guests: true }
        });
      } else {
        this.$router.push({ name: 'Participantes' });
      }
    },
    update: function update(isInvalid, touched) {
      var _this2 = this;

      if (isInvalid === false) {
        this.loading = true;
        var guest = this.guest;
        if (guest.has_visa) {
          guest.visa_validity = null;
        }
        this.$http.put('guests/' + this.guest.id, { guest: guest }).then(function (response) {
          _this2.loading = false;
          _this2.$router.push({
            name: 'Participante',
            params: { id: _this2.guest.participant.user_id, guests: true, updatedGuest: true }
          });
        }).catch(function (response) {
          _this2.hasErrors = true;
          _this2.loading = false;
        });
      }
    },
    _updateMask: function _updateMask() {
      this.guest.cpf = this.guest.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    },
    downloadAttachment: function downloadAttachment() {
      var _this3 = this;

      this.loading = true;
      this.$http.get('guests/' + this.guest.id + '/attachment').then(function (response) {
        var linkSource = 'data:image/*;base64,' + response.data.attachment_binary;
        var downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = _this3.guest.attachment_name;
        downloadLink.click();
        _this3.loading = false;
      }).catch(function () {
        _this3.notFound = true;
        _this3.loading = false;
      });
    }
  },
  validations: function validations() {
    return {
      guest: {
        name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(23) },
        cell_phone: { minLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(15), maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(15) },
        cpf: { minLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(14), maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(14) },
        rg: { minLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(6), maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(18) },
        validade_rg: { minLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(10), maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(10) },
        kinship: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        ptc_count: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        date_of_birth: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        gender: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        observation: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(200) },
        special_needs: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(150) },

        passport_first_name: !this.guest.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] } : {},
        passport_last_name: !this.guest.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] } : {},
        passport_number: !this.guest.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] } : {},
        nacionality: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        passport_authority: !this.guest.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] } : {},
        passport_validity: !this.guest.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] } : {},
        start_city: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        return_city: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Table_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methods_helpers__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tables',
  components: { cTable: __WEBPACK_IMPORTED_MODULE_1__components_Table_vue__["a" /* default */] },
  props: {
    participantId: false,
    editOrder: false,
    guestId: false
  },
  data: function data() {
    return {
      items: [],
      fields: [{ key: 'item', label: 'Item', sortable: true }, { key: 'description', label: 'Descrição', sortable: true }],
      excelFields: {
        'Item': 'item',
        'Descrição': 'description'
      },
      excelData: [],
      loading: false
    };
  },

  watch: {
    participantId: function participantId(val) {
      this.mount();
    },
    editOrder: function editOrder(val) {
      this.mount();
    }
  },
  methods: {
    mount: function mount() {
      var _this = this;

      if (this.participantId !== false && this.participantId !== undefined) {
        this.$http.get('flights/' + this.participantId).then(function (response) {
          console.log(response.data);
          var search = 'extras';
          if (_this.guestId) {
            search = 'guestsExtras';
          }

          response.data[search].forEach(function (data) {
            if (_this.guestId) {
              if (_this.guestId !== data.guest_id) {
                return;
              }
            }
            var order = {};
            if (data.status === 0) {
              order.status = 'Pendente';
            } else {
              order.status = 'Concluído';
            }

            order.description = data.extra.formatted_name !== null ? data.extra.formatted_name : data.observation;

            if (data.extra.name === 'flight') {
              order.item = 'Voo';
              order.description = data.desc;
            } else if (data.extra.name !== 'return_transfer' && data.extra.name !== 'departure_transfer' && data.extra.name !== 'refuse_transfer' && data.extra.name !== 'observation') {
              order.item = 'Extra';
            } else if (data.extra.name === 'observation') {
              order.item = 'Observação';
            } else {
              order.item = 'Adicional';
            }
            if (data.extra.name === 'hosting_days') {
              order.item = 'Dias da hospedagem extra';
              order.description = data.hosting_days;
            }
            order.updated = __WEBPACK_IMPORTED_MODULE_2__methods_helpers__["a" /* formatDate */](data.updated_at, true);
            order.code = data.code;
            order.actions = { show: true, id: data.id, edit: 'order' };
            _this.items.push(order);
          });

          if (!_this.guestId) {
            var flight = response.data.participantFlight;
            if (flight) {
              if (flight.different_flight) {
                _this.items.push({
                  item: 'Voo',
                  description: 'Algum dos acompanhantes necessita de um voo diferente'
                });
              }
              if (flight.extend_date) {
                _this.items.push({
                  item: 'Voo',
                  description: 'Deseja realizar alteração de data de retorno e/ou adicionar trechos nesse voo mediante disponibilidade e custo adicional.'
                });
              }
              if (flight.flight_id === 26) {
                _this.items.push({
                  item: 'Voo',
                  description: 'Opção 21 - Data Oficial - Chegada dia 18 e saída dia 22 de abril.'
                });
              }
            }
          }

          _this.items = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(_this.items, 'item');
          _this.excelData = _this.items;
        });
      }
    }
  },
  mounted: function mounted() {
    this.mount();
  }
});

/***/ }),
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.editOrder)?_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('c-table',{attrs:{"striped":"","caption":"<i class='fa fa-shopping-cart'></i> Lista de Pedidos","items":_vm.items,"fields":_vm.fields}})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Erro!","ok-variant":"danger","ok-only":""},on:{"ok":function($event){_vm.hasErrors = false}},model:{value:(_vm.hasErrors),callback:function ($$v) {_vm.hasErrors=$$v},expression:"hasErrors"}},[_vm._v("\n    Verifique todos os campos e tente novamente.\n  ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Info!","ok-variant":"primary","ok-only":""},on:{"ok":function($event){_vm.notFound = false}},model:{value:(_vm.notFound),callback:function ($$v) {_vm.notFound=$$v},expression:"notFound"}},[_vm._v("\n    Acompanhante não encontrado.\n  ")]),_vm._v(" "),_c('b-row',[(!_vm.editOrder && !_vm.showGuests)?_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Acompanhante: "+_vm._s(_vm.guest.passport_first_name)+" "+_vm._s(_vm.guest.passport_last_name)+"\n        ")]),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Nome conforme passaporte"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.passport_first_name.$invalid},attrs:{"type":"text","maxlength":"50"},model:{value:(_vm.guest.passport_first_name),callback:function ($$v) {_vm.$set(_vm.guest, "passport_first_name", $$v)},expression:"guest.passport_first_name"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Sobrenome conforme passaporte"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.passport_last_name.$invalid},attrs:{"type":"text","maxlength":"50"},model:{value:(_vm.guest.passport_last_name),callback:function ($$v) {_vm.$set(_vm.guest, "passport_last_name", $$v)},expression:"guest.passport_last_name"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Número do passaporte"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.passport_number.$invalid},attrs:{"type":"text","maxlength":"50"},model:{value:(_vm.guest.passport_number),callback:function ($$v) {_vm.$set(_vm.guest, "passport_number", $$v)},expression:"guest.passport_number"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Nacionalidade"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.nacionality.$invalid},attrs:{"type":"text","maxlength":"23"},model:{value:(_vm.guest.nacionality),callback:function ($$v) {_vm.$set(_vm.guest, "nacionality", $$v)},expression:"guest.nacionality"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"País de emissão"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.passport_authority.$invalid},attrs:{"type":"text","maxlength":"23"},model:{value:(_vm.guest.passport_authority),callback:function ($$v) {_vm.$set(_vm.guest, "passport_authority", $$v)},expression:"guest.passport_authority"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Validade do passaporte"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999'),expression:"'99/99/9999'"}],class:{'is-invalid': _vm.$v.guest.passport_validity.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.passport_validity),callback:function ($$v) {_vm.$set(_vm.guest, "passport_validity", $$v)},expression:"guest.passport_validity"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Nome de crachá"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.name.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.name),callback:function ($$v) {_vm.$set(_vm.guest, "name", $$v)},expression:"guest.name"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Celular"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999-9999'),expression:"'(99) 99999-9999'"}],class:{'is-invalid': _vm.$v.guest.cell_phone.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.cell_phone),callback:function ($$v) {_vm.$set(_vm.guest, "cell_phone", $$v)},expression:"guest.cell_phone"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"CPF"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"}],class:{'is-invalid': _vm.$v.guest.cpf.$invalid},attrs:{"type":"text"},on:{"input":_vm._updateMask},model:{value:(_vm.guest.cpf),callback:function ($$v) {_vm.$set(_vm.guest, "cpf", $$v)},expression:"guest.cpf"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"RG"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.rg.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.rg),callback:function ($$v) {_vm.$set(_vm.guest, "rg", $$v)},expression:"guest.rg"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Validade do RG"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.validade_rg.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.validade_rg),callback:function ($$v) {_vm.$set(_vm.guest, "validade_rg", $$v)},expression:"guest.validade_rg"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data de Nascimento"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999'),expression:"'99/99/9999'"}],class:{'is-invalid': _vm.$v.guest.date_of_birth.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.date_of_birth),callback:function ($$v) {_vm.$set(_vm.guest, "date_of_birth", $$v)},expression:"guest.date_of_birth"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Sexo","label-cols":3,"horizontal":true}},[_c('b-form-radio-group',{staticStyle:{"margin-top":"35px","margin-left":"-45px"},attrs:{"options":[
                  {text: 'Masculino', value: '1'},
                  {text: 'Feminino', value: '2'} ],"value":"1"},model:{value:(_vm.guest.gender),callback:function ($$v) {_vm.$set(_vm.guest, "gender", $$v)},expression:"guest.gender"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Grau de parentesco"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.kinship,"value":"Selecione o grau"},model:{value:(_vm.guest.kinship),callback:function ($$v) {_vm.$set(_vm.guest, "kinship", $$v)},expression:"guest.kinship"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Restrição alimentar"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.foods,"value":"Selecione o tipo"},model:{value:(_vm.guest.food_id),callback:function ($$v) {_vm.$set(_vm.guest, "food_id", $$v)},expression:"guest.food_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Descrição da restrição"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.guest.other_food),callback:function ($$v) {_vm.$set(_vm.guest, "other_food", $$v)},expression:"guest.other_food"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Necessidades Especiais"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.pwdList,"value":"Selecione o tipo"},model:{value:(_vm.guest.pwd_id),callback:function ($$v) {_vm.$set(_vm.guest, "pwd_id", $$v)},expression:"guest.pwd_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Descrição da necessidade especial"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.guest.other_pwd),callback:function ($$v) {_vm.$set(_vm.guest, "other_pwd", $$v)},expression:"guest.other_pwd"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Não possui passaporte?","label-cols":1,"horizontal":false}},[_c('b-form-checkbox',{attrs:{"value":"1"},model:{value:(_vm.guest.has_passport),callback:function ($$v) {_vm.$set(_vm.guest, "has_passport", $$v)},expression:"guest.has_passport"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Cidade de origem"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.start_city.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.start_city),callback:function ($$v) {_vm.$set(_vm.guest, "start_city", $$v)},expression:"guest.start_city"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Cidade de retorno"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.return_city.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.return_city),callback:function ($$v) {_vm.$set(_vm.guest, "return_city", $$v)},expression:"guest.return_city"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Qtd de PTC's anteriores"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.guest.ptc_count.$invalid},attrs:{"type":"text"},model:{value:(_vm.guest.ptc_count),callback:function ($$v) {_vm.$set(_vm.guest, "ptc_count", $$v)},expression:"guest.ptc_count"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Observação"}},[_c('b-input-group',[_c('b-form-textarea',{attrs:{"rows":2,"max-rows":3},model:{value:(_vm.guest.observation),callback:function ($$v) {_vm.$set(_vm.guest, "observation", $$v)},expression:"guest.observation"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-button',{attrs:{"variant":"default"},on:{"click":_vm.back}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v("  Voltar\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.update(_vm.$v.guest.$invalid, _vm.$v.guest.$touch())}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("  Salvar\n            ")])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('order-list',{attrs:{"participantId":_vm.guest.participant_id,"guestId":_vm.guest.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddacb36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(416);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddacb36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      user: {
        registration: '',
        password: ''
      },
      loading: false,
      hasErrors: false
    };
  },
  mounted: function mounted() {
    if (this.$store.state.user !== null || window.localStorage.getItem('origami_admin_user') !== 'null') {
      this.$router.push({ name: 'Dashboard' });
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$http.post('auth/login', this.user).then(function (response) {
        _this.$store.commit('setUser', response.data.user);
        _this.$store.commit('setToken', response.data.token);
        if (window.localStorage) {
          window.localStorage.setItem('origami_admin_user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.user));
          window.localStorage.setItem('origami_admin_token', response.data.token);
        }
        _this.$http.defaults.headers.Authorization = 'Bearer ' + window.localStorage.getItem('origami_admin_token');
        _this.hasErrors = false;
        _this.$router.push({ name: 'Dashboard' });
      }).catch(function (e) {
        _this.loading = false;
        _this.hasErrors = true;
      });
    }
  }
});

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Erro!","ok-variant":"danger","ok-only":""},on:{"ok":function($event){_vm.hasErrors = false}},model:{value:(_vm.hasErrors),callback:function ($$v) {_vm.hasErrors=$$v},expression:"hasErrors"}},[_vm._v("\n    Usuário ou senha inválidos\n  ")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"4"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v("Login")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Entre com sua conta")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.registration),expression:"user.registration"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Matrícula"},domProps:{"value":(_vm.user.registration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "registration", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Senha"},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-4",attrs:{"variant":"primary"},on:{"click":_vm.login}},[_vm._v("Entrar")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f66d299_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(419);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f66d299_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! Você está perdido.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n            A página que você procura não existe. Clique "),_c('router-link',{attrs:{"to":{name: 'Dashboard'}}},[_vm._v("aqui")]),_vm._v(" para voltar.\n          ")],1)]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"})])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942c40c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(422);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942c40c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Houston, we have a problem!")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n            A página que você está procurando encontra-se temporariamente indisponível. Clique \n            "),_c('router-link',{attrs:{"to":{name: 'Dashboard'}}},[_vm._v("aqui")]),_vm._v(" para voltar.\n          ")],1)]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"})])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7469d7c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(432);
function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7469d7c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Table_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_guests_List_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_orders_Edit_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_orders_List_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__methods_helpers__ = __webpack_require__(27);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forms',
  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default.a
  },
  components: {
    'order-list': __WEBPACK_IMPORTED_MODULE_5__views_orders_List_vue__["a" /* default */],
    'order-edit': __WEBPACK_IMPORTED_MODULE_4__views_orders_Edit_vue__["a" /* default */],
    'guests-list': __WEBPACK_IMPORTED_MODULE_3__views_guests_List_vue__["a" /* default */],
    cTable: __WEBPACK_IMPORTED_MODULE_2__components_Table_vue__["a" /* default */]
  },
  data: function data() {
    return {
      name: '',
      cpd: '',
      flight: '',
      foods: [],
      pwdList: [],
      cities: [],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      loading: false,
      hasErrors: false,
      notFound: false,
      emailSended: false,
      updateMessage: '',
      editOrder: false,
      currentOrder: false,
      showGuests: false,
      obs: '',
      participant: {
        id: false,
        badgeName: '',
        email: '',
        cpf: '',
        rg: '',
        validadeRg: '',
        registration: '',
        cellPhone: '',
        dateOfBirth: '',
        gender: '',

        hasPassport: false,
        confirmInfo: false,
        completed: false,
        foodId: '',
        otherFood: '',
        ptcCount: 0,
        pcd: '',
        attachment_name: '',
        passportFirstName: "",
        passportLastName: "",
        passportNumber: "",
        nacionality: "",
        passportAuthority: ""
      },
      tickets: [],
      fields: [{ key: 'code', label: 'Protocolo', sortable: true }, { key: 'observation', label: 'Observação', sortable: true }, { key: 'name', label: 'Usuário', sortable: true }, { key: 'created_at', label: 'Criação', sortable: true }],
      userId: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.$http.get('sync').then(function (response) {
      var data = response.data;
      _this.cities = data.cities.map(function (city) {
        return { value: city.id, text: city.name };
      });
      _this.foods = data.foods.map(function (food) {
        return { value: food.id, text: food.name };
      });
      _this.pwdList = data.pwd.map(function (pwd) {
        return { value: pwd.id, text: pwd.name };
      });
    });
    this.userId = this.$router.history.current.params.id;
    this.$http.get('users/' + this.userId).then(function (response) {
      var user = response.data.user;
      if (user.completed !== null) {
        _this.participant = user.participant;
        _this.participant.dateOfBirth = __WEBPACK_IMPORTED_MODULE_6__methods_helpers__["a" /* formatDate */](_this.participant.dateOfBirth);
        if (_this.participant.passportValidity !== null) {
          _this.participant.passportValidity = __WEBPACK_IMPORTED_MODULE_6__methods_helpers__["a" /* formatDate */](_this.participant.passportValidity);
        }
      } else {
        _this.participant.badgeName = user.badgeName;
        _this.participant.email = user.email;
      }
      _this.name = user.badgeName;
      _this.cpd = user.registration;
      _this.flight = user.participant.flight ? user.participant.flight.flight.group_number : 'Sem grupo de vôo selecionado';
      _this.loading = false;
      if (_this.$router.history.current.params.guests === true) {
        _this.showGuests = true;
      }
      if (_this.$router.history.current.params.updatedGuest === true) {
        _this.updatedGuest = true;
      }
      var uri = window.location.toString();
      if (uri.indexOf('/true/true') > 0) {
        var cleanUri = uri.substring(0, uri.indexOf('/true/true'));
        window.history.replaceState({}, document.title, cleanUri);
      }
      _this.$router.history.current.params.guests = false;
      _this.$router.history.current.params.updatedGuest = false;
    }).catch(function (error) {
      console.error(error);
      _this.notFound = true;
      _this.loading = false;
    });
  },

  methods: {
    ticketGenerate: function ticketGenerate() {
      var _this2 = this;

      this.loading = true;

      var data = { observation: this.obs, user_id: this.userId };

      this.$http.post('tickets', data).then(function (response) {
        _this2.obs = '';
      }).finally(function () {
        _this2.showTickets();
      });
    },
    showTickets: function showTickets() {
      var _this3 = this;

      this.loading = true;
      this.$http.get('tickets/' + this.userId).then(function (response) {
        _this3.tickets = response.data.tickets.map(function (ticket) {
          ticket.name = ticket.user.badge_name;
          return ticket;
        });
      }).finally(function () {
        _this3.loading = false;
        _this3.$root.$emit('bv::show::modal', 'ticketDialog');
      });
    },
    update: function update(isInvalid, touched) {
      var _this4 = this;

      if (isInvalid === false) {
        this.loading = true;
        var participant = this.participant;

        this.$http.post('participants', participant).then(function (response) {
          _this4.participant.id = response.data.participant.id;
          _this4.loading = false;
          _this4.$router.push({ name: 'Participantes', params: { updated: true } });
        }).catch(function (response) {
          _this4.hasErrors = true;
          _this4.loading = false;
        });
      }
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert: function showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    notify: function notify() {
      var _this5 = this;

      this.loading = true;
      this.$http.post('users/notify', { id: [this.userId] }).then(function (response) {

        _this5.loading = false;
        _this5.emailSended = true;
        switch (response.data.status[0].status) {
          case 'success':
            _this5.updateMessage = 'Email enviado com sucesso!';
            break;
          case 'already_sent':
            _this5.updateMessage = 'Email já enviado previamente';
            break;

          default:
            _this5.updateMessage = response.data.status[0].status;
            break;
        }
      }).catch(function (error) {
        console.error(error);
        _this5.loading = false;
      });
    },
    generateNewPassword: function generateNewPassword() {
      var _this6 = this;

      this.loading = true;
      this.$http.post('users/generate-new-pwd', { id: this.userId }).then(function (response) {
        _this6.loading = false;
        _this6.emailSended = true;
        _this6.updateMessage = 'Senha nova: ' + response.data.pwd;
      }).catch(function (error) {
        console.error(error);
        _this6.loading = false;
      });
    },
    downloadAttachment: function downloadAttachment() {
      var _this7 = this;

      this.loading = true;
      this.$http.get('participants/' + this.participant.id + '/attachment').then(function (response) {
        var linkSource = 'data:image/*;base64,' + response.data.attachment_binary;
        var downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = _this7.participant.attachmentName;
        downloadLink.click();
        _this7.loading = false;
      }).catch(function (error) {
        console.error(error);
        _this7.notFound = true;
        _this7.loading = false;
      });
    }
  },
  validations: function validations() {
    return {
      participant: {
        email: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(150) },

        cpf: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(14), maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(14) },
        rg: { minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(6), maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(18) },
        validadeRg: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(10), maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(10) },
        registration: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(150) },
        cellPhone: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(14) },
        dateOfBirth: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(10),
          isValidDate: function isValidDate(value) {
            return __WEBPACK_IMPORTED_MODULE_6__methods_helpers__["b" /* isValidDate */](value, true);
          }
        },
        gender: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
        startCity: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
        returnCity: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },

        passportFirstName: !this.participant.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] } : {},
        passportLastName: !this.participant.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] } : {},
        passportNumber: !this.participant.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] } : {},
        nacionality: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
        passportAuthority: !this.participant.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] } : {},
        passportValidity: !this.participant.hasPassport ? { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] } : {}
      }
    };
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb77020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(428);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb77020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Table_vue__ = __webpack_require__(28);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tables',
  components: { cTable: __WEBPACK_IMPORTED_MODULE_0__components_Table_vue__["a" /* default */] },
  props: {
    participantId: false
  },
  data: function data() {
    return {
      items: [],
      fields: [{ key: 'passportFirstName', label: 'Nome', sortable: true }, { key: 'selected', label: 'Acompanhante', sortable: true }, { key: 'ptcCount', label: 'Qtd de PTC\'s', sortable: true }, { key: 'type', label: 'Parentesco', sortable: true }, { key: 'formattedPassport', label: 'Possui passaporte?', sortable: true }, { key: 'flightLabel', label: 'Voo', sortable: true }, { key: 'actions', label: 'Ações' }],
      excelFields: {
        'Nome': 'passportFirstName',
        'Acompanhante': 'selected',
        'Qtd de PTCs': 'ptcCount',
        'Parentesco': 'type',
        'Possui passaporte?': 'formattedPassport'
      },
      excelData: [],
      loading: false,
      updatedGuest: false,
      dismissCountDown: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var btn = document.querySelector('.btn-participant');
    btn.addEventListener('click', function () {
      _this.$parent.showGuests = false;
    });
    if (this.$parent.updatedGuest === true) {
      this.dismissCountDown = 10;
    }
    if (this.$parent.participant.guests !== undefined) {
      this.items = this.$parent.participant.guests.map(function (guest) {
        guest.formattedPassport = guest.hasPassport === 1 ? 'Não' : 'Sim';
        guest.selected = guest.flight !== null ? 'Qualificado' : guest.extra ? 'Extra' : 'Não';
        guest.flightLabel = guest.flight !== null ? 'Grupo ' + guest.flight.flight.group_number : '---';
        guest.actions = {
          show: true,
          id: guest.id,
          edit: 'guest',
          modal: true,
          modalTitle: 'Dados do acompanhante',
          route: 'Acompanhante'
        };
        return guest;
      });
      this.excelData = this.items;
    }
  },

  methods: {
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":"success"},on:{"dismissed":function($event){_vm.dismissCountDown = 0},"dismiss-count-down":_vm.countDownChanged}},[_c('p',[_vm._v("Acompanhante atualizado com sucesso!")]),_vm._v(" "),_c('b-progress',{attrs:{"variant":"success","max":10,"value":_vm.dismissCountDown,"height":"4px"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('c-table',{attrs:{"striped":"","caption":"<i class='fa fa-users'></i> Lista de Acompanhantes <button class='btn btn-default btn-sm pull-right btn-participant'><i class='fa fa-arrow-left'></i>&nbsp; Voltar para o Participante</button>","items":_vm.items,"fields":_vm.fields,"excelFields":_vm.excelFields,"excelData":_vm.excelData,"excelName":"Acompanhantes"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6feac236_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(431);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6feac236_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forms',
  props: {
    orderId: false
  },
  data: function data() {
    return {
      order: { code: '', status: '' },
      loading: false
    };
  },

  watch: {
    orderId: function orderId(val) {
      this.mount();
    }
  },
  mounted: function mounted() {
    this.mount();
  },

  methods: {
    mount: function mount() {
      var _this = this;

      this.loading = true;
      this.$http.get('orders/' + this.orderId).then(function (response) {
        _this.loading = false;
        _this.order = response.data.order;
      }).catch(function (res) {
        _this.loading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.loading = true;
      this.$http.put('orders/' + this.orderId, { status: this.order.status, code: this.order.code }).then(function (response) {
        _this2.loading = false;
        _this2.$parent.editOrder = false;
        _this2.$parent.showAlert();
      }).catch(function (res) {
        _this2.loading = false;
      });
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Participante:\n        ")]),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Código de confirmação"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.order.code),callback:function ($$v) {_vm.$set(_vm.order, "code", $$v)},expression:"order.code"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Status"}},[_c('b-form-select',{attrs:{"plain":true,"options":[{value: 0, text: 'Pendente'}, {value: 1, text: 'Concluído'}],"value":"Status"},model:{value:(_vm.order.status),callback:function ($$v) {_vm.$set(_vm.order, "status", $$v)},expression:"order.status"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-button',{attrs:{"variant":"default"},on:{"click":function($event){_vm.$parent.editOrder = false}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v("  Voltar\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.update}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("  Salvar\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Erro!","ok-variant":"danger","ok-only":""},on:{"ok":function($event){_vm.hasErrors = false}},model:{value:(_vm.hasErrors),callback:function ($$v) {_vm.hasErrors=$$v},expression:"hasErrors"}},[_vm._v("\n    Verifique todos os campos e tente novamente.\n  ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Info!","ok-variant":"primary","ok-only":""},on:{"ok":function($event){_vm.notFound = false}},model:{value:(_vm.notFound),callback:function ($$v) {_vm.notFound=$$v},expression:"notFound"}},[_vm._v("\n    Usuário não encontrado.\n  ")]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Info!","ok-variant":"primary","ok-only":""},on:{"ok":function($event){_vm.emailSended = false}},model:{value:(_vm.emailSended),callback:function ($$v) {_vm.emailSended=$$v},expression:"emailSended"}},[_vm._v("\n    "+_vm._s(_vm.updateMessage)+"\n  ")]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":"success"},on:{"dismissed":function($event){_vm.dismissCountDown=0},"dismiss-count-down":_vm.countDownChanged}},[_c('p',[_vm._v("Pedido atualizado com sucesso!")]),_vm._v(" "),_c('b-progress',{attrs:{"variant":"success","max":_vm.dismissSecs,"value":_vm.dismissCountDown,"height":"4px"}})],1),_vm._v(" "),_c('b-row',[(!_vm.editOrder && !_vm.showGuests)?_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Participante: "+_vm._s(_vm.name)+" / CPD: "+_vm._s(_vm.cpd)+" / Grupo de Voo: "+_vm._s(_vm.flight)+"\n          "),_c('b-button',{staticClass:"pull-right btn-sm",attrs:{"variant":"default"},on:{"click":function($event){_vm.generateNewPassword()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v("  Gerar uma nova senha\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"pull-right btn-sm",attrs:{"variant":"default"},on:{"click":function($event){_vm.notify()}}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v("  Enviar email de registro\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"pull-right btn-sm",attrs:{"variant":"default"},on:{"click":function($event){_vm.showGuests = !_vm.showGuests}}},[_c('i',{staticClass:"fa fa-users"}),_vm._v("  Visualizar Acompanhantes\n          ")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_vm._v(" ")]),_vm._v(" "),_c('b-button',{staticClass:"pull-right btn-sm",attrs:{"variant":"default"},on:{"click":_vm.showTickets}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v("  Protocolos\n          ")])],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Nome conforme passaporte"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.passportFirstName.$invalid},attrs:{"type":"text","maxlength":"23"},model:{value:(_vm.participant.passportFirstName),callback:function ($$v) {_vm.$set(_vm.participant, "passportFirstName", $$v)},expression:"participant.passportFirstName"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Sobrenome conforme passaporte"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.passportLastName.$invalid},attrs:{"type":"text","maxlength":"23"},model:{value:(_vm.participant.passportLastName),callback:function ($$v) {_vm.$set(_vm.participant, "passportLastName", $$v)},expression:"participant.passportLastName"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Número do passaporte"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.passportNumber.$invalid},attrs:{"type":"text","maxlength":"23"},model:{value:(_vm.participant.passportNumber),callback:function ($$v) {_vm.$set(_vm.participant, "passportNumber", $$v)},expression:"participant.passportNumber"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Nacionalidade"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.nacionality.$invalid},attrs:{"type":"text","maxlength":"23"},model:{value:(_vm.participant.nacionality),callback:function ($$v) {_vm.$set(_vm.participant, "nacionality", $$v)},expression:"participant.nacionality"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"País de emissão"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.passportAuthority.$invalid},attrs:{"type":"text","maxlength":"23"},model:{value:(_vm.participant.passportAuthority),callback:function ($$v) {_vm.$set(_vm.participant, "passportAuthority", $$v)},expression:"participant.passportAuthority"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Validade do passaporte"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999'),expression:"'99/99/9999'"}],class:{'is-invalid': _vm.$v.participant.passportValidity.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.passportValidity),callback:function ($$v) {_vm.$set(_vm.participant, "passportValidity", $$v)},expression:"participant.passportValidity"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Email"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.email.$invalid},attrs:{"type":"email"},model:{value:(_vm.participant.email),callback:function ($$v) {_vm.$set(_vm.participant, "email", $$v)},expression:"participant.email"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"CPF"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"}],class:{'is-invalid': _vm.$v.participant.cpf.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.cpf),callback:function ($$v) {_vm.$set(_vm.participant, "cpf", $$v)},expression:"participant.cpf"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"RG"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.rg.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.rg),callback:function ($$v) {_vm.$set(_vm.participant, "rg", $$v)},expression:"participant.rg"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Validade RG"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.validadeRg.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.validadeRg),callback:function ($$v) {_vm.$set(_vm.participant, "validadeRg", $$v)},expression:"participant.validadeRg"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Telefone celular"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999-9999'),expression:"'(99) 99999-9999'"}],class:{'is-invalid': _vm.$v.participant.cellPhone.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.cellPhone),callback:function ($$v) {_vm.$set(_vm.participant, "cellPhone", $$v)},expression:"participant.cellPhone"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Data de Nascimento"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('99/99/9999'),expression:"'99/99/9999'"}],class:{'is-invalid': _vm.$v.participant.dateOfBirth.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.participant, "dateOfBirth", $$v)},expression:"participant.dateOfBirth"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Sexo","label-cols":3,"horizontal":true}},[_c('b-form-radio-group',{staticStyle:{"margin-top":"35px","margin-left":"-45px"},attrs:{"options":[
                  {text: 'Masculino', value: '1'},
                  {text: 'Feminino', value: '2'} ],"value":"1"},model:{value:(_vm.participant.gender),callback:function ($$v) {_vm.$set(_vm.participant, "gender", $$v)},expression:"participant.gender"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Cidade de origem"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.startCity.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.startCity),callback:function ($$v) {_vm.$set(_vm.participant, "startCity", $$v)},expression:"participant.startCity"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Cidade de retorno"}},[_c('b-input-group',[_c('b-form-input',{class:{'is-invalid': _vm.$v.participant.returnCity.$invalid},attrs:{"type":"text"},model:{value:(_vm.participant.returnCity),callback:function ($$v) {_vm.$set(_vm.participant, "returnCity", $$v)},expression:"participant.returnCity"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Restrição alimentar"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.foods,"value":"Selecione o tipo"},model:{value:(_vm.participant.foodId),callback:function ($$v) {_vm.$set(_vm.participant, "foodId", $$v)},expression:"participant.foodId"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Descrição da restrição"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.participant.otherFood),callback:function ($$v) {_vm.$set(_vm.participant, "otherFood", $$v)},expression:"participant.otherFood"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Necessidades especiais"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.pwdList,"value":"Selecione o tipo"},model:{value:(_vm.participant.pwdId),callback:function ($$v) {_vm.$set(_vm.participant, "pwdId", $$v)},expression:"participant.pwdId"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Descrição da necessidade especial"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.participant.otherPwd),callback:function ($$v) {_vm.$set(_vm.participant, "otherPwd", $$v)},expression:"participant.otherPwd"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Não possui passaporte?","label-cols":1,"horizontal":false}},[_c('b-form-checkbox',{attrs:{"value":"1"},model:{value:(_vm.participant.hasPassport),callback:function ($$v) {_vm.$set(_vm.participant, "hasPassport", $$v)},expression:"participant.hasPassport"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-button',{attrs:{"variant":"default"},on:{"click":function($event){_vm.$router.push({name: 'Participantes'})}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v("  Voltar\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.update(_vm.$v.participant.$invalid, _vm.$v.participant.$touch())}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("  Salvar\n            ")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"ticketDialog","size":"lg","ok-only":"","title":"Protocolos"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"md":"5"}},[_c('b-form-fieldset',{attrs:{"label":"Observação"}},[_c('b-input-group',[_c('b-form-textarea',{attrs:{"rows":2,"max-rows":3,"placeholder":"Aqui você pode deixar uma observação relacionada ao protocolo."},model:{value:(_vm.obs),callback:function ($$v) {_vm.obs=$$v},expression:"obs"}})],1)],1),_vm._v(" "),_c('b-button',{staticClass:"btn-sm",attrs:{"variant":"default"},on:{"click":_vm.ticketGenerate}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v("  Gerar Protocolo\n                  ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('c-table',{attrs:{"striped":"","caption":"<i class='fa fa-ticket'></i> Lista de Protocolos","items":_vm.tickets,"fields":_vm.fields}})],1)],1)],1)])],1)])])],1),_vm._v(" "),(!_vm.showGuests)?_c('order-list',{attrs:{"participantId":_vm.participant.id,"showGuests":_vm.showGuests,"editOrder":_vm.editOrder}}):_vm._e(),_vm._v(" "),(_vm.editOrder)?_c('order-edit',{attrs:{"orderId":_vm.currentOrder}}):_vm._e(),_vm._v(" "),(_vm.showGuests)?_c('guests-list',{attrs:{"participantId":_vm.participant.id}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d18ec20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(435);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d18ec20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Table_vue__ = __webpack_require__(28);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tables',
  components: { cTable: __WEBPACK_IMPORTED_MODULE_0__components_Table_vue__["a" /* default */] },
  data: function data() {
    return {
      loading: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      items: [],
      fields: [{ key: 'badge_name', label: 'Nome', sortable: true }, { key: 'formatted_rank', label: 'Categoria', sortable: true }, { key: 'registration', label: 'Matrícula', sortable: true }, { key: 'register_email', label: 'Email', sortable: true }, { key: 'actions', label: 'Ações' }]
    };
  },
  mounted: function mounted() {
    if (this.$router.history.current.params.updated === true) {
      this.showAlert();
    }
    this.getUsers();
  },

  methods: {
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert: function showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getUsers: function getUsers(status) {
      var _this = this;

      this.loading = true;
      var url = status !== undefined ? '?status=' + status : '';
      this.$http.get('users' + url).then(function (response) {
        _this.items = response.data.users;
        _this.items.forEach(function (item) {
          item.created_at = '';
          item.updated_at = '';
          item.actions = { show: true, id: item.id, route: 'Participante' };
          switch (item.register_email) {
            case 'success':
              item.register_email = 'Enviado';
              break;
            case null:
              item.register_email = 'Não enviado';
              break;

            default:
              break;
          }
        });
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"block-screen"},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]):_vm._e(),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":"success"},on:{"dismissed":function($event){_vm.dismissCountDown=0},"dismiss-count-down":_vm.countDownChanged}},[_c('p',[_vm._v("Participante atualizado com sucesso!")]),_vm._v(" "),_c('b-progress',{attrs:{"variant":"success","max":_vm.dismissSecs,"value":_vm.dismissCountDown,"height":"4px"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('c-table',{attrs:{"striped":"","caption":"<i class='fa fa-users'></i> Lista de Participantes","items":_vm.items,"fields":_vm.fields}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(61);





var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: 'https://backend.origamiturismosistema.com.br/api/admin/',

  headers: {
    Authorization: 'Bearer ' + window.localStorage.getItem('origami_admin_token'),
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  validateStatus: function validateStatus(status) {
    if (status === 401 || status === 403) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setUser', null);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setToken', null);
      window.localStorage.setItem('origami_admin_user', null);
      window.localStorage.setItem('origami_admin_token', null);
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ 'name': 'Login' });
    }
    return status >= 200 && status < 300;
  }
});

if (window.localStorage && window.localStorage.getItem('origami_admin_user') !== 'undefined') {
  if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user !== window.localStorage.getItem('origami_admin_user')) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setUser', JSON.parse(window.localStorage.getItem('origami_admin_user')));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setToken', window.localStorage.getItem('origami_admin_token'));
  }
}

api.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ })
]),[122]);


// WEBPACK FOOTER //
// static/js/app.99a51a3cb254d29dc44e.js